export const uploadFileToS3SignedUrl = async (signedUrl: string, file: File): Promise<Response> => {
  const response = await fetch(signedUrl, {
    method: 'PUT',
    headers: {
      'Content-Type': file.type,
    },
    body: file,
  });

  return response;
};
